// src/pages/StateDashboard.js
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import api from "../services/api";
import "../styles/dashboard.css";

export default function StateDashboard() {
  const [stats, setStats] = useState({
    totalBeneficiaries: 0,
    totalPayments: 0,
    totalRevenue: 0,
    districts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const [beneficiariesRes, paymentsRes] = await Promise.all([
        api.get("/beneficiary/all"),
        api.get("/payments").catch(() => ({ data: [] }))
      ]);
      
      const beneficiaries = beneficiariesRes.data || [];
      const payments = paymentsRes.data || [];
      const paidPayments = payments.filter(p => p.status === "PAID");
      const totalRevenue = paidPayments.reduce((sum, p) => sum + (p.amount || 0), 0);
      
      // Get unique districts from beneficiaries
      const uniqueDistricts = new Set(beneficiaries.map(b => b.district).filter(Boolean));
      
      setStats({
        totalBeneficiaries: beneficiaries.length,
        totalPayments: payments.length,
        totalRevenue: totalRevenue,
        districts: uniqueDistricts.size
      });
    } catch (err) {
      console.error("Failed to load dashboard data:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <Sidebar />
        <div className="dashboard-content">
          <div className="loading-spinner">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-title">
            <h1>State Coordinator Dashboard</h1>
            <p>Welcome to State Level Dashboard</p>
          </div>
          <div className="header-date">{new Date().toLocaleDateString()}</div>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">👥</div>
            <div className="stat-info">
              <h3>Total Beneficiaries</h3>
              <p>{stats.totalBeneficiaries}</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div className="stat-info">
              <h3>Total Payments</h3>
              <p>{stats.totalPayments}</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🏦</div>
            <div className="stat-info">
              <h3>Total Revenue</h3>
              <p>₹{stats.totalRevenue.toLocaleString()}</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🏢</div>
            <div className="stat-info">
              <h3>Districts Covered</h3>
              <p>{stats.districts}</p>
            </div>
          </div>
        </div>

        <div className="revenue-card">
          <h2>State Overview</h2>
          <div style={{ padding: "20px", textAlign: "center" }}>
            <p>Welcome to the State Coordinator Dashboard</p>
            <p>You can manage beneficiaries across all districts from here.</p>
          </div>
        </div>
      </div>
    </div>
  );
}